<p>
  This feature is no longer available. Please use the <br />
  new feature by pressing the button below <br />
</p>
<a routerLink="/view-board">To Qtime Flex</a>
